export const telemetryEndpoint: string = "https://telemetry.meerkat.wildboar.software";
export const emailSignupEndpoint: string = "https://email.meerkat.wildboar.software";
export const updatesDomain: string = "updates.meerkat.wildboar.software";
export const CONTEXT: string = "CONTEXT";
export const MINIMUM_MAX_ATTR_SIZE: number = 8;
